
import TemplateStore from '../templates/template-store';
import containingActiveOrientation from '../edit-area/containing-active-orientation.js';
import prismItemInterrogator from '../misc/prism-item-interrogator';

// I have barely little idea what the hell is going on here and it looks like
// Taha didn't fare any better either, according to his comments.

// Looking for function getTemplateOrientation(tags)? This has moved to template-inetrrogator.js

// ------------------------------------------------------------------------------------------

// Returns current active section
function getCurrentSection() {
  return prismItemInterrogator.getCurrentSection();
}

// ------------------------------------------------------------------------------------------

function getFoldersBySection(templates, edges) { // returns designs (aka folders) for specific section
  const wrap = TemplateStore.currentWrap();
  const activeSection = getCurrentSection();
  const folders = [];

  for (const template of templates) {
    if (template.suitable_for.indexOf(activeSection) === -1) continue;

    // Slim down for canvas wraps
    if (edges && wrap && wrap.group) {
      if (wrap.group.group !== template.group) {
        continue;
      }
    }

    folders.push(template);
  }

  return folders;
}

// ------------------------------------------------------------------------------------------

// returns if current theme is for card theme
function isCard(foldersBySection) {
  const [firstFolder] = (foldersBySection || []);

  if (firstFolder && firstFolder.templates.length > 0) {
    return firstFolder.templates[0].tags.indexOf('card') !== -1;
  }

  return false;
}

// ------------------------------------------------------------------------------------------

function filterTemplates(templates, filter, section) {
  templates = templates.filter((template) => (filter === '*' || filter === template['no-photos']) && template.sections.includes(section));

  if (section !== 0) {
    templates = templates.filter((template) => containingActiveOrientation(template));
  }

  return templates.sort((a, b) => (a.name > b.name ? 1 : -1));
}

function getCurrentTemplateSlots() {
  if (!window.activeView || !activeView.template || !activeView.template.pso) {
    return 1;
  }

  return activeView.template.pso.filter((id) => !(id.match(/^optional-|:/))).length;
}

// ------------------------------------------------------------------------------------------
function getCurrentTemplateOrientation() {
  if (!activeView.template) return null;
  return TemplateStore.getOrientation(activeView.template.size);
}

// ------------------------------------------------------------------------------------------

function numberOfPhotosInTemplateText(number) {
  switch (number) {
    case 0:
      return 'Text only';
    case 1:
      return '1 photo';
    default:
      return `${number} photos`;
  }
}

// ------------------------------------------------------------------------------------------
function numberOfTextSolotsInTemplateText(number) {
  switch (number) {
    case 0:
      return;
    case 1:
      return '1 text';
    default:
      return `${number} texts`;
  }
}

// ------------------------------------------------------------------------------------------

export {
  getCurrentSection,
  getFoldersBySection,
  isCard,
  filterTemplates,
  getCurrentTemplateSlots,
  getCurrentTemplateOrientation,
  numberOfPhotosInTemplateText,
  numberOfTextSolotsInTemplateText,
};
